export function familySurnameCaption(person: {surname: string | null; surnameInferred?: boolean; visuraMatch?: {immobili: number} | null}): string {
  if (person.visuraMatch) {
    const n = person.visuraMatch.immobili;
    return n === 1 ? "Cointestatario in visura · 1 immobile" : `Cointestatario in visura · ${n} immobili`;
  }
  if (!person.surname) return "Cognome non indicato";
  if (person.surnameInferred) return "Cognome ricavato · identità da verificare";
  return "Cognome presente nella fonte";
}
